import { render, staticRenderFns } from "./Unterricht.vue?vue&type=template&id=29083561&scoped=true&"
import script from "./Unterricht.vue?vue&type=script&lang=js&"
export * from "./Unterricht.vue?vue&type=script&lang=js&"
import style0 from "./Unterricht.vue?vue&type=style&index=0&id=29083561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29083561",
  null
  
)

export default component.exports